export default __webpack_public_path__ + "static/media/15.62a88a70.png";